module.exports = __webpack_public_path__ + "media/img/event/sponsor/tradevsa-logo-dab3bcfb30746405b56eb0f47baccd11.png";